// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Admin panel  (CSV download for the order and customer lists)
// Builds a CSV in the browser and saves it. Every cell is quoted, and a cell starting with = + - @ (or a tab/CR) gets a leading apostrophe so a
// spreadsheet never runs customer-typed text (a name, an address) as a formula.
// Neighbours: pages/admin/AdminOrders, pages/admin/AdminCustomers.
// ─────────────────────────────────────────────────────────────────────────────
const cell = (value: string | number) => {
  const text = String(value);
  return `"${(/^[=+\-@\t\r]/.test(text) ? `'${text}` : text).replace(/"/g, '""')}"`;
};

export function downloadCsv(filename: string, rows: (string | number)[][]) {
  const blob = new Blob([rows.map((row) => row.map(cell).join(",")).join("\r\n")], { type: "text/csv;charset=utf-8" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
}
